import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
import "../Print.css";
type ReturnDataProps = {
  voidReturn: {
    trans_return_count: number;
    trans_return_total: number;
    item_void_count: number;
    trans_void_total: number;
    item_return_count: number;
    item_return_total: number;
    item_void_total: number;
    trans_void_count: number;
  };
  source: string;
};

export const ReturnSummary: FunctionComponent<ReturnDataProps> = ({
  voidReturn,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Return Summary</Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "50%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Item Return
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.item_return_count
                    ? voidReturn.item_return_count
                    : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.item_return_total
                    ? voidReturn.item_return_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Transaction Return
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.trans_return_count
                    ? voidReturn.trans_return_count
                    : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.trans_return_total
                    ? voidReturn.trans_return_total
                    : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Item Void
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.item_void_count
                    ? voidReturn.item_void_count
                    : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.item_void_total
                    ? voidReturn.item_void_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Transaction Void
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.trans_void_count
                    ? voidReturn.trans_void_count
                    : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {voidReturn.trans_void_total
                    ? voidReturn.trans_void_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Suspended
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headColor}
                ></TableCell>
                <TableCell
                  align="right"
                  className={classes.headColor}
                ></TableCell>
              </TableRow> */}
              {/* <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Resume
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headColor}
                ></TableCell>
                <TableCell
                  align="right"
                  className={classes.headColor}
                ></TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell align="left" className={classes.headCell}>
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                ></TableCell>
                <TableCell align="right" className={classes.headCell}>
                  {voidReturn.item_void_total
                    ? voidReturn.item_void_total
                    : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
